import React, { useState, useEffect } from 'react';
import logo from './logo.svg';
import PrivateRoute from './PrivateRoute';
import {AuthContext, useAuth} from "./context/auth";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useRouteMatch,
  Redirect,
  Link
} from "react-router-dom";
import Permissions from './pages/Permissions'
import config from './config';
import Guest from './pages/Guest'
import Login from './pages/Login'
import Home from './pages/Home'
import Files from './pages/Files'
import Users from './pages/Users'
import User from './pages/User'
import UserSaveVars from './pages/UserSaveVars'
import Vars from './pages/Vars'
import OfferLines from './pages/OfferLines'
import OfferLine from './pages/OfferLine'
import Notifications from './pages/Notifications'
import Notification from './pages/Notification'
import Cohorts from './pages/Cohorts'
import Withdrawals from './pages/Withdrawals'
import Cohort from './pages/Cohort'
import UniversalCollectionView from './pages/UniversalCollectionView'
import UniversalVew from './pages/UniversalVew'
import Changes from './pages/Changes'
import Versions from './pages/Versions'
import GameServers from './pages/GameServers'
import Products from './pages/Products'
import Product from './pages/Product'
import Events from './pages/Events'
import Event from './pages/Event'

import Leaderboards from './pages/Leaderboards'
import Leaderboard from './pages/Leaderboard'
import ServiceTests from './pages/ServiceTests'
import Calendar from './pages/Calendar'

import fetcher from "./context/fetcher";
import _ from "lodash";
import About from "./pages/About";

class App extends React.Component {
  constructor(props){
    super(props)
    this.PUBLIC_URL = process.env.PUBLIC_URL;
    this.PUBLIC_TITLE = process.env.PUBLIC_TITLE;
    let existingAuth = JSON.parse(localStorage.getItem("auth-m3t"));
    this.state = {
      token: existingAuth ? existingAuth.token : null,
      role: existingAuth ? existingAuth.role : null,
      config: existingAuth ? existingAuth.config : null,
      username: existingAuth ? existingAuth.username : null,
    };
    this.sessionRefreshTimer = null;
    this.setToken = this.setToken.bind(this);
    this.getVars = this.getVars.bind(this);
    this.refreshSession = this.refreshSession.bind(this);
  }
  setToken(data) {
    localStorage.setItem("auth-m3t", JSON.stringify(data));
    this.setState(data, () => {
      // Вызываем getVars после обновления состояния
      if (data && data.token) {
        this.refreshSession(true);
      }
    })
  }
  componentDidMount() {
    if (this.state.token) {
      this.refreshSession(true);
    }
    this.sessionRefreshTimer = setInterval(() => {
      if (this.state.token && this.state.role === "guest") {
        this.refreshSession();
      }
    }, 5000);
  }

  componentWillUnmount() {
    if (this.sessionRefreshTimer) {
      clearInterval(this.sessionRefreshTimer);
    }
  }

  async refreshSession(loadVars = false) {
    if (!this.state.token) {
      return;
    }
    try {
      let response = await fetcher(`${config.API()}me`);
      let authData = await response.json();
      localStorage.setItem("auth-m3t", JSON.stringify(authData));
      this.setState(authData, () => {
        if (loadVars) {
          this.getVars();
        }
      });
    } catch (error) {
      console.error("Failed to refresh session", error);
    }
  }

  async getVars() {
    try {
    let responseVars = await fetcher(`${config.API()}collection/vars`);
    let vars = await responseVars.json();
    let tmp = _.find(vars, x => x.key == "AppLogoUrl");
    let logoUrl = tmp ? tmp.value : null;
    this.setState({logoUrl});

    tmp = _.find(vars, x => x.key == "AppFaviconUrl");
    let faviconUrl = tmp ? tmp.value : null;
    if (faviconUrl) {
      // Находим существующий <link rel="icon"> или создаем новый
      let faviconLink = document.querySelector('link[rel="icon"]');
      if (!faviconLink) {
        faviconLink = document.createElement('link');
        faviconLink.rel = 'icon';
        document.head.appendChild(faviconLink);
      }
      // Устанавливаем новый URL для favicon
      faviconLink.href = faviconUrl;
    } else {
      // Если faviconUrl отсутствует, используем дефолтный favicon
      let faviconLink = document.querySelector('link[rel="icon"]');
      if (faviconLink) {
        faviconLink.href = '%PUBLIC_URL%/favicon.ico';
      }
    }

    tmp = _.find(vars, x => x.key == "AppTitle");
    let title = tmp ? tmp.value : null;
    if(title){
      document.title = title;
      this.setState({title});
    }

    } catch (error) {
      console.error("Failed to load app vars", error);
    }
  }

  render() {
    return (
        <AuthContext.Provider value={{ authToken: this.state.token,
          role: this.state.role,
          username: this.state.username,
          config: this.state.config,
          setAuthToken: this.setToken }}>
          <Router basename={process.env.PUBLIC_URL}>
            <div id="wrapper">
              {this.state.token && <SideBar logoUrl={this.state.logoUrl} miniTitle = {this.state.title} username={ this.state.username} role={this.state.role} config = {this.state.config || {}} />}
              <div id="content-wrapper" className="l d-flex flex-column">
                <div id="content">
                  <div className="container-fluid">
                    <div className="route mt-2">
                      <Switch>
                        <Route exact path="/login" component={Login} />
                        <Route exact path="/guest" component={Guest}/>
                        <PrivateRoute exact path="/vars" component={Vars} />
                        {_.get(this.state.config,"modules.users") && <PrivateRoute exact path="/users" component={Users} />}
                        {_.get(this.state.config,"modules.users") && <PrivateRoute exact path="/users/:id" component={User} />}
                        {_.get(this.state.config,"modules.users") && <PrivateRoute exact path="/user-save-vars" component={UserSaveVars} />}
                        <PrivateRoute exact path="/files" component={Files} />
                        <PrivateRoute exact path="/files/*" component={Files} />
                        <PrivateRoute exact path="/gameServers" component={GameServers} />
                        <PrivateRoute exact path="/offer-lines" component={OfferLines} />
                        <PrivateRoute exact path="/offer-lines/:id" component={OfferLine} />
                        <PrivateRoute exact path="/notifications" component={Notifications} />
                        <PrivateRoute exact path="/notifications/:id" component={Notification} />
                        <PrivateRoute exact path="/cohorts" component={Cohorts} />
                        <PrivateRoute exact path="/withdrawals" component={Withdrawals} />
                        <PrivateRoute exact path="/cohorts/:id" component={Cohort} />
                        <PrivateRoute exact path="/view/:collectionName" component={UniversalCollectionView} />
                        <PrivateRoute exact path="/view/:collectionName/:id" component={UniversalVew} />
                        <PrivateRoute exact path="/changes" component={Changes} />
                        <PrivateRoute exact path="/versions" component={Versions} />
                        <PrivateRoute exact path="/products" component={Products} />
                        <PrivateRoute exact path="/products/:id" component={Product} />
                        <PrivateRoute exact path="/events" component={Events} />
                        <PrivateRoute exact path="/events/:id" component={Event} />
                        <PrivateRoute exact path="/calendar" component={Calendar} />
                        <PrivateRoute exact path="/leaderboards" component={Leaderboards} />
                        <PrivateRoute exact path="/leaderboards/:id" component={Leaderboard} />
                        <PrivateRoute exact path="/service-tests" component={ServiceTests} />
                        <PrivateRoute exact path="/about" component={About} />
                        {this.state.role == "master" && <PrivateRoute exact path="/permissions" component={Permissions}/>}
                        <PrivateRoute exact path="/" component={Home}/>
                      </Switch>
                    </div>
                  </div>
                </div>
                <footer className="sticky-footer bg-light">
                  <div className="container my-auto">
                    <div className="copyright text-center my-auto">
                    </div>
                  </div>
                </footer>
              </div>
              <div id="json" className="modal fade" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabelJSON"
                   aria-hidden="true">
                <div className="modal-dialog modal-xl" role="document">
                  <div className="modal-content">
                    <form>
                      <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">State</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <pre id="json-display"></pre>
                      </div>
                      <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button id="saveJson" className="btn btn-primary" type="button" onClick={ this.props.saveHandler }>Ok</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </Router>
        </AuthContext.Provider>
    );
  }
}


function SideBar(props){
  const { setAuthToken } = useAuth();
  const [isHide, setIsHide] = useState(false);
  const [versions, setVersions] = useState({serverCached: 0});
  const [isRun, setRun] = useState(false);

  function sideBarClick(e) {
    e.preventDefault();
    setIsHide(!isHide)
  }
  function logOut(e) {
    e.preventDefault();
    setAuthToken({token: null, username: "guest", role: "guest"});
    window.location = "/login"
  }

  function getVersions(){
    let versionsA = JSON.parse(JSON.stringify(versions));
    fetcher(`${config.API()}storage/version`)
        .then(response => response.json())
        .then(response => {
          Object.assign(versionsA, {
            serverId: response.serverId,
            storageServerVersionInDB: response.serverVersion,
            storageAdminVersionInDB: response.adminVersion,
            dockerImage: response.dockerImage,
            adminNotSaved: response.adminNotSaved
          });
          setVersions(versionsA);
        });

    setTimeout(getVersions, 10000)
  }
  useEffect(() => {
    // call api or anything
    if(!isRun) {
      setRun(true);
      getVersions();
    }
  });
  return (
      <div>
        <button className={"sidebarBtn btn btn-circle btn-light border-primary " + (isHide && "hide")} onClick={sideBarClick}>
          <i className={`fas ${isHide ? "fa-chevron-right" : "fa-chevron-left"}`}/>
        </button>
        <ul className={`l navbar-nav bg-gradient-darkblue sidebar sidebar-dark accordion ` +
        (isHide ? " hide" : "") +
        (versions.storageServerVersion != versions.storageServerVersionInDB ? " bg-gradient-darkred" : "" ) +
        (versions.adminNotSaved ? " bg-gradient-" : "" )
        }
            id="accordionSidebar">
          <Link className="d-flex align-items-center justify-content-center p-1" to = "/">
              <div className="my-logo" style={{
                backgroundImage: "url("+(props.logoUrl || "../logoEdit.png")+")"
              }}></div>
          </Link>
          <hr className="sidebar-divider my-0"/>
          <Link className="sidebar-brand d-flex align-items-center justify-content-center" to = "/">
            <div className="sidebar-brand-text mx-3">{props.miniTitle}</div>
          </Link>
          <hr className="sidebar-divider my-0"/>
          {_.get(props.config, "modules.users") == "true" && <MenuLink to="/users" icon="fas fa-fw fa-user" label="Users" activeOnlyWhenExact={true}></MenuLink>}
          <li className="nav-item">
            <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseAlbums"
               aria-expanded="true" aria-controls="collapseAlbums">
              <i className="fas fa-fw fa-rocket"></i>
              <span>LiveOps</span>
            </a>
            <div id="collapseAlbums" className="collapse" aria-labelledby="headingAlbums"
                 data-parent="#accordionSidebar">
              <div className="bg-white py-2 collapse-inner rounded">
                <CollapsedLink to="/Calendar" icon="fas fa-fw fa-list" label="Calendar" activeOnlyWhenExact={true}></CollapsedLink>
                {_.get(props.config, "modules.events") == "true" && <CollapsedLink to="/Events" icon="fas fa-fw fa-rocket" label="Events" activeOnlyWhenExact={true}></CollapsedLink>}
                {_.get(props.config, "modules.offers") == "true" && <CollapsedLink to="/Offer-lines" icon="fas fa-fw fa-bank" label="Offer-lines" activeOnlyWhenExact={true}></CollapsedLink>}
                {_.get(props.config, "modules.offers") == "true" && <CollapsedLink to="/Products" icon="fas fa-fw fa-rocket" label="Products" activeOnlyWhenExact={true}></CollapsedLink>}
                {_.get(props.config, "modules.notifications") == "true" && <CollapsedLink to="/Notifications" icon="fas fa-fw fa-paper-plane" label="Notifications" activeOnlyWhenExact={true}></CollapsedLink> }
              </div>
            </div>
          </li>
          {_.get(props.config, "modules.cohorts") == "true" && <MenuLink to="/Cohorts" icon="fas fa-fw fa-users" label="Cohorts" activeOnlyWhenExact={true}></MenuLink>}
          {_.get(props.config, "modules.leaderboards") == "true" && <MenuLink to="/Leaderboards" icon="fas fa-fw fa-users" label="Leaderboards" activeOnlyWhenExact={true}></MenuLink>}
          {_.get(props.config, "modules.teams") == "true" && <MenuLink to="/view/teams-srv-teams" icon="fas fa-fw fa-institution" label="Teams" activeOnlyWhenExact={true}></MenuLink>}
          {_.get(props.config, "modules.files") == "true" && <MenuLink to="/Files" icon="fas fa-fw fa-save" label="Files" activeOnlyWhenExact={true}></MenuLink>}
          {_.get(props.config, "modules.withdrawals") == "true" && <MenuLink to="/Withdrawals" icon="fas fa-fw fa-money" label="Withdrawals" activeOnlyWhenExact={true}></MenuLink>}
          {_.get(props.config, "modules.gameServers") == "true" && <MenuLink to="/GameServers" icon="fas fa-fw fa-server" label="GameServers" activeOnlyWhenExact={true}></MenuLink>}
          <li className="nav-item">
            <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseUtilities"
               aria-expanded="true" aria-controls="collapseUtilities">
              <i className="fas fa-fw fa-wrench"></i>
              <span>Utilities</span>
            </a>
            <div id="collapseUtilities" className="collapse" aria-labelledby="headingUtilities"
                 data-parent="#accordionSidebar">
              <div className="bg-white py-2 collapse-inner rounded">
                <CollapsedLink to="/vars" icon="fa-balance-scale" label="Vars" activeOnlyWhenExact={true}></CollapsedLink>
                {_.get(props.config, "modules.users") == "true" && <CollapsedLink to="/user-save-vars" icon="fa-balance-scale" label="UserVars" activeOnlyWhenExact={true}></CollapsedLink>}
                <CollapsedLink to="/service-tests" icon="fa-balance-scale" label="Service tests" activeOnlyWhenExact={true}></CollapsedLink>
                <CollapsedLink to="/permissions" icon="fa-balance-scale" label="Permissions" activeOnlyWhenExact={true}></CollapsedLink>
                <CollapsedLink to="/changes" icon="fa-balance-scale" label="Changes" activeOnlyWhenExact={true}></CollapsedLink>
                <CollapsedLink to="/versions" icon="fa-balance-scale" label="Versions" activeOnlyWhenExact={true}></CollapsedLink>
              </div>
            </div>
          </li>

          <MenuLink to="/About" icon="fas fa-fw fa-info-circle" label="About" activeOnlyWhenExact={true}></MenuLink>
          <hr className="sidebar-divider my-0"/>
          <li className={" nav-item"}>
            <Link onClick={logOut}  className="nav-link mask waves-effect waves-light rgba-white-slight " to="#">
              <i className="fas fa-fw fa-sign-out-alt"></i>Logout ({props.username})
            </Link>
          </li>
          <hr className="sidebar-divider my-0"/>
          <div className="text-white mx-3 pt-2 pb-2 small text-nowrap text-truncate" title="EnvId and DockerBuildID"><span className="text-gray-500">env: </span> {versions.serverId}.{versions.dockerImage}</div>
          <div className="text-white mx-3 pt-2 pb-2 small text-nowrap text-truncate" title="storageAdminVersionInDB | storageServerVersionInDB | ServerCached">
            <span className="text-gray-500 cp" >versions: </span>
            {versions.storageAdminVersionInDB} | {versions.storageServerVersionInDB} | {versions.serverCached}
          </div>
        </ul>
      </div>
  )

}
function CollapsedLink({ label, to, icon, activeOnlyWhenExact }) {
  let match = useRouteMatch({
    path: to,
    exact: activeOnlyWhenExact
  });

  return (
      <Link className={(match && 'active') + " collapse-item mask waves-effect waves"} to={to}>{label}</Link>
  );
}
function MenuLink({ label, to, icon, activeOnlyWhenExact }) {
  let match = useRouteMatch({
    path: to,
    exact: activeOnlyWhenExact
  });

  return (
      <li className={(match && 'active') + " nav-item"}>
        <Link className="nav-link mask waves-effect waves-light rgba-white-slight " to={to}>
          <i className={icon + " fas fa-fw"}></i>
          <span>{label}</span>
        </Link>
      </li>
  );
}

export default App;
